import script from "./AtomChartPie.vue?vue&type=script&setup=true&lang=ts"
export * from "./AtomChartPie.vue?vue&type=script&setup=true&lang=ts"

import "./AtomChartPie.vue?vue&type=style&index=0&id=4e31f11a&lang=css"

const __exports__ = script;

export default __exports__